import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toTwoDecimalPlaces } from '../../../helpers';

// Components
import { Link } from 'react-router-dom';
import { Container, Button } from 'reactstrap';
import FullPageLayout from '../../../../components/FullPageLayout';
import { ResponsiveImage } from 'dabbl-react-components';
import LegalLinks from '../../../../components/LegalLinks';
import CloseAccountPage from '../../components/CloseAccountPage';
import HowDoesThisWorkPopUp from '../../components/HowDoesThisWorkPopUp';

// Images
import {COUPON_IMAGE} from "../../../../retailerValues";
import {logAmplitudeAccountScreen} from "../../../../amplitude";

class HasCouponPage extends Component {

  static propTypes = {
    cardNumber: PropTypes.string.isRequired,
    cardAmount: PropTypes.number.isRequired,
    couponExpirationDate: PropTypes.string.isRequired,
    isPopupOpen: PropTypes.bool.isRequired,
    onTogglePopup: PropTypes.func.isRequired,
  }

    componentDidMount() {
        logAmplitudeAccountScreen()
    }
    
  render() {
    const {
      cardNumber,
      cardAmount,
      couponExpirationDate,
      isPopupOpen,
      onTogglePopup,
    } = this.props;

    return (
      <div>
        <FullPageLayout
          className="center-content-vertically"
          style={{
            justifyContent: 'space-between',
            padding: '1rem 0'
          }}
        >

          {/* Close Button - top right X */}
          <CloseAccountPage />

          {/* Middle Content */}
          <div>
            <Container>
              <div className="text-center">
                <h1>Savings Added!</h1>
              </div>

              <ResponsiveImage
                className="HasCouponPage_cardImg"
                src={COUPON_IMAGE}
                alt="You have a coupon!"
                aspectRatio="16:9"
              />

              <div className="text-center">
                <h3 style={{fontWeight: 'bold'}}>
                  ${toTwoDecimalPlaces(cardAmount)}
                </h3>
                <h5>Savings Ready</h5>
              </div>

              {/* Coupon Expiration */}
              {couponExpirationDate && (
                <div className="AddCouponPage_cardAmt_text">
                  Coupon expires {couponExpirationDate}
                </div>
              )}

              {/* Card Number */}
              <div className="AddCouponPage_cardAmt_text">
                Card Number: {cardNumber}
              </div>

              <div
                className="text-center"
                style={{
                  maxWidth: '275px',
                  margin: '1rem auto 0 auto',
                }}
              >
                <b>It may take up to 48 hours for your in-store redemption
                to be reflected here</b>. Coupon must be redeemed before
                adding additional coupons.
              </div>

              <div className="text-center" style={{margin: '1.5rem 0'}}>
                <Link to="/app/campaigns" className="no-link">
                  <Button color="secondary" style={{padding: '1rem 1.5rem'}}>
                    Keep Earning
                  </Button>
                </Link>
              </div>

            </Container>
          </div>

          {/* Flex Spacer */}
          <div style={{height: '1px'}}></div>

          {/* Footer Links */}
          <div>
            <HowDoesThisWorkPopUp
              isOpen={isPopupOpen}
              onTogglePopup={onTogglePopup}
            />

            <LegalLinks style={{paddingTop: '1rem'}} />
          </div>

        </FullPageLayout>
      </div>
    );
  }
}

export default HasCouponPage;



// WEBPACK FOOTER //
// ./src/pages/Account/containers/HasCouponPage/HasCouponPage.js